<div class="user-profile-page">
  <div class="user-profile-card">
    <div class="profile-header">
      <div class="profile-icon">
        <lucide-icon name="user" [size]="24"></lucide-icon>
      </div>

      <h1>{{ "userProfile.title" | translate }}</h1>
    </div>

    <app-ui-back-button [previousPages]="['dashboard.title', 'userProfile.title']" (goToPreviousPage)="onBack()"></app-ui-back-button>

    <div class="spinner" *ngIf="isLoading"></div>

    <div class="profile-content" *ngIf="!isLoading">
      <div class="field-row" [formGroup]="userInfoForm">
        <!-- Login field -->
        <div class="form-field">
          <label for="profile-login">{{ "loginForm.login" | translate }}</label>

          <div class="input-wrapper">
            <lucide-icon name="user" [size]="19"></lucide-icon>
            <input id="profile-login" formControlName="login" />
          </div>
        </div>
      </div>

      <app-organization-switcher class="profile-organizations" idPrefix="user-profile-orgId-"></app-organization-switcher>

      <div class="profile-actions">
        <button type="button" class="secondary-button" *ngIf="!changePassword" (click)="changePassword = true">
          <lucide-icon name="key-round" [size]="18"></lucide-icon>
          {{ "userProfile.changePassword" | translate }}
        </button>
      </div>

      <ng-container *ngIf="changePassword">
        <h2>{{ "userProfile.changePassword" | translate }}</h2>

        <div class="field-row" [formGroup]="pwdChangeForm">
          <!-- Old password field -->
          <div class="form-field">
            <label for="profile-old-password">{{ "userProfile.oldPassword" | translate }}</label>

            <div class="input-wrapper">
              <lucide-icon name="lock" [size]="19"></lucide-icon>
              <input
                id="profile-old-password"
                formControlName="oldPassword"
                [type]="showOldPassword ? 'text' : 'password'"
                autocomplete="current-password"
              />

              <button
                type="button"
                class="visibility-button"
                (click)="showOldPassword = !showOldPassword"
                [attr.aria-label]="showOldPassword ? ('password.hide' | translate) : ('password.show' | translate)"
              >
                <lucide-icon [name]="showOldPassword ? 'eye' : 'eye-off'" [size]="19"></lucide-icon>
              </button>
            </div>

            <span
              class="field-error"
              *ngIf="pwdChangeForm.controls.oldPassword.touched && pwdChangeForm.controls.oldPassword.errors?.['required']"
            >
              {{ "common.required" | translate }}
            </span>
          </div>

          <!-- New password field -->
          <div class="form-field">
            <label for="profile-new-password">{{ "resetPassword.password" | translate }}</label>

            <div class="input-wrapper">
              <lucide-icon name="lock" [size]="19"></lucide-icon>
              <input
                id="profile-new-password"
                formControlName="newPassword"
                [type]="showNewPassword ? 'text' : 'password'"
                autocomplete="new-password"
              />

              <button
                type="button"
                class="visibility-button"
                (click)="showNewPassword = !showNewPassword"
                [attr.aria-label]="showNewPassword ? ('password.hide' | translate) : ('password.show' | translate)"
              >
                <lucide-icon [name]="showNewPassword ? 'eye' : 'eye-off'" [size]="19"></lucide-icon>
              </button>
            </div>

            <span
              class="field-error"
              *ngIf="pwdChangeForm.controls.newPassword.touched && pwdChangeForm.controls.newPassword.errors?.['required']"
            >
              {{ "common.required" | translate }}
            </span>

            <span
              class="field-error"
              *ngIf="pwdChangeForm.controls.newPassword.touched && pwdChangeForm.controls.newPassword.errors?.['pattern']"
            >
              {{ "password.pattern" | translate }}
            </span>
          </div>

          <!-- Confirm new password field -->
          <div class="form-field">
            <label for="profile-confirm-new-password">{{ "resetPassword.confirmPassword" | translate }}</label>

            <div class="input-wrapper">
              <lucide-icon name="lock-keyhole" [size]="19"></lucide-icon>
              <input
                id="profile-confirm-new-password"
                formControlName="confirmNewPassword"
                [type]="showConfirmNewPassword ? 'text' : 'password'"
              />

              <button
                type="button"
                class="visibility-button"
                (click)="showConfirmNewPassword = !showConfirmNewPassword"
                [attr.aria-label]="showConfirmNewPassword ? ('password.hide' | translate) : ('password.show' | translate)"
              >
                <lucide-icon [name]="showConfirmNewPassword ? 'eye' : 'eye-off'" [size]="19"></lucide-icon>
              </button>
            </div>

            <span
              class="field-error"
              *ngIf="pwdChangeForm.controls.confirmNewPassword.touched && pwdChangeForm.controls.confirmNewPassword.errors?.['required']"
            >
              {{ "common.required" | translate }}
            </span>

            <span
              class="field-error"
              *ngIf="pwdChangeForm.controls.confirmNewPassword.touched && pwdChangeForm.controls.confirmNewPassword.errors?.['matching']"
            >
              {{ "password.confirm.mismatch" | translate }}
            </span>
          </div>
        </div>

        <div class="profile-actions">
          <button type="button" class="secondary-button" (click)="closePasswordChange()" [disabled]="pwdChangeForm.disabled">
            {{ "button.cancel" | translate }}
          </button>

          <button type="button" class="primary-button" (click)="onSubmit()" [disabled]="pwdChangeForm.disabled">
            {{ "button.confirm" | translate }}
          </button>
        </div>
      </ng-container>

      <p class="created-at">
        {{ "userProfile.createdAt" | translate }}
        {{ userinfo.createdAt | date: "dd/MM/YYYY" }}
      </p>
    </div>
  </div>
</div>
